import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Coupon } from 'commons/models/coupon';

import { AppContext } from 'commons-ui';

import { getFormDefaults } from '../../utils/formConfig';
import { dehydrateFormData } from '../../utils/formDataParser';
import useService from '../../utils/useService';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateCoupon } = useService();

	const createCoupon = (createdData: Coupon) => {
		setShowLoader(true);
		requestCreateCoupon(app.appName, { ...createdData, isDisabled: true }).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(`Error: ${res?.data?.error || 'Error occured while creating the partner coupon'}`, { type: 'error' });
					setShowLoader(false);
					return;
				}
				showAlert('Record created');
				setShowLoader(false);
				history.goBack();
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		createCoupon(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: getFormDefaults(), showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
